import { render, staticRenderFns } from "./Radio.vue?vue&type=template&id=a5619a2a&scoped=true"
import script from "./Radio.vue?vue&type=script&lang=js"
export * from "./Radio.vue?vue&type=script&lang=js"
import style0 from "./Radio.vue?vue&type=style&index=0&id=a5619a2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5619a2a",
  null
  
)

export default component.exports